import { Injectable } from '@angular/core';
import { BudgetDeterminationSystem, ProcurementProjectDTO, RequestMaterialDTO } from '../../api/plyca-dtos-v2';
import { FormConfig, FormConfigHelper } from '../../components/forms/form.objects';
import { formatDate } from '@angular/common';
import * as  moment from 'moment';

@Injectable()
export class ProcurementProjectAYMADAMValidations implements FormConfigHelper {

  constructor() { }

  // FUNCIONES DE USO EXCLUSIVO DE ACUERDOS MARCO ////

  public activeSomeEntrepreneurs(model: any) {
    let active = model?.context?.configurations?.activeSomeEntrepreneurs?.value;
    return active;
  }

  public valueOnlyEntrepreneur(model: any) {
    let active = model?.context?.configurations?.activeSomeEntrepreneurs?.value;
    if (!active) {
      return true;
    }
    return model.contractingSystem.onlyEntrepreneur;
  }

  public defaultValueOnlyEntrepreneur(model: any) {
    let active = model?.context?.configurations?.activeSomeEntrepreneurs?.value;
    if (!active) {
      return true;
    }
    return null;
  }

  public defaultValueSomeEntrepreneurs(model: any) {
    let active = model?.context?.configurations?.activeSomeEntrepreneurs?.value;
    if (active) {
      return true;
    }
    return null;
  }

  public valueFrameworkAgreementAwardType(model: any) {
    let active = model?.context?.configurations?.activeSomeEntrepreneurs?.value;
    if (!active) {
      return 'U';
    } else {
      return 'V';
    }
  }


  public visibleAssumptionsNewTender(model: any) {
    let fameworkAgreementTerm_aymad = model.contractingSystem?.fameworkAgreementTerm_aymad != undefined && model.contractingSystem?.fameworkAgreementTerm_aymad != null && model.contractingSystem.fameworkAgreementTerm_aymad === true
    let plannedTenderBasedFrameworkAgreementAdapt = model.contractingSystem?.plannedTenderBasedFrameworkAgreementAdapt != undefined && model.contractingSystem?.plannedTenderBasedFrameworkAgreementAdapt != null && model.contractingSystem.plannedTenderBasedFrameworkAgreementAdapt == 2;

    return fameworkAgreementTerm_aymad && plannedTenderBasedFrameworkAgreementAdapt;
  }

  public valuePlannedTenderBasedFrameworkAgreementAdapt(model: any) {
    let someEntrepreneurs = false;
    if (model.contractingSystem?.someEntrepreneurs != undefined && model.contractingSystem?.someEntrepreneurss != null && model.contractingSystem?.someEntrepreneurss) {
      someEntrepreneurs = true;
    }

    if (someEntrepreneurs) {
      if (model.contractingSystem?.fameworkAgreementTerm_aymad != undefined && model.contractingSystem?.fameworkAgreementTerm_aymad != null && model.contractingSystem?.fameworkAgreementTerm_aymad === false) {
        return 1;
      }
    }

    return model.contractingSystem.plannedTenderBasedFrameworkAgreementAdapt;
  }
  public visiblePlannedTenderBasedFrameworkAgreementAdapt(model: any) {
    let someEntrepreneurs = false;
    if (model.contractingSystem?.someEntrepreneurs != undefined && model.contractingSystem?.someEntrepreneurs != null && model.contractingSystem?.someEntrepreneurs) {
      someEntrepreneurs = true;
    }

    if (someEntrepreneurs) {
      if (model.contractingSystem?.fameworkAgreementTerm_aymad != undefined && model.contractingSystem?.fameworkAgreementTerm_aymad != null) {
        return true;
      }
    }

    return false;
  }

  public valueYearExercise_LotBudgetAccountLineAM(model: any) {
    return '-';
  }

  public visibleDefinitiveGuaranteeTypeAM(model: any) {
    let openSimplifiedAbreviated = model.parent?.type?.identifier == 'ASA<>PROCEDIMIENTOSCONTRA';
    //if (model?.noDefinitiveGuarantee != null && model?.noDefinitiveGuarantee) {
    if (model?.definitiveGuarantee != null) {
      if (!model?.definitiveGuarantee) {
        return false;
      } else {
        if (!openSimplifiedAbreviated && model.parent.contractingSystem?.someEntrepreneurs !== null && model.parent.contractingSystem?.someEntrepreneurs) {
          return true;
        }
      }
    }

    return false;
  }

  public visibleComplementaryGuaranteeAM(model: any) {

    let isServices = model.parent?.classification?.typeCode?.identifier == '04<>TIPOEXPTE';
    let isGoods = model.parent?.classification?.typeCode?.identifier == '02<>TIPOEXPTE';
    let definitiveGuarantee = model?.definitiveGuarantee != null && model?.definitiveGuarantee;
    let someEntrepreneurs = model?.parent?.contractingSystem?.someEntrepreneurs != undefined && model?.parent?.contractingSystem?.someEntrepreneurs != null && model?.parent.contractingSystem?.someEntrepreneurs;

    let openSimplifiedAbreviated = model.parent?.type?.identifier == 'ASA<>PROCEDIMIENTOSCONTRA';

    let visible = !openSimplifiedAbreviated && ((isServices || isGoods) && definitiveGuarantee);

    if (visible) {
      //Varios Adjudicatarios
      if (someEntrepreneurs) {
        //if (model?.budget?.definitiveGuaranteeType_am !== undefined && model?.budget?.definitiveGuaranteeType_am !== null && model?.budget?.definitiveGuaranteeType_am == 1) {
        if (model?.budget?.definitiveGuaranteeType_am !== undefined && model?.budget?.definitiveGuaranteeType_am !== null && model?.budget?.definitiveGuaranteeType_am) {
          return true;
        }
      } else {
        return true;
      }
    }
    return false;
  }


  public valueTenderBasedFrameworkAgreementAdaptAM(model: any) {
    // POR AQUI
    if (model?.parent?.contractingSystem?.plannedTenderBasedFrameworkAgreementAdapt != undefined && model?.parent?.contractingSystem?.plannedTenderBasedFrameworkAgreementAdapt != null) {
      let plannedTenderBasedFrameworkAgreementAdapt = model?.parent?.contractingSystem?.plannedTenderBasedFrameworkAgreementAdapt;
      if (plannedTenderBasedFrameworkAgreementAdapt == 0 || plannedTenderBasedFrameworkAgreementAdapt == 1) {
        return plannedTenderBasedFrameworkAgreementAdapt;
      } else if (plannedTenderBasedFrameworkAgreementAdapt == 2) {
        //Sin y Con nueva licitación
        //Sin lotes
        if (!model?.parent?.breakdownLot?.apportioned) {
          return plannedTenderBasedFrameworkAgreementAdapt;
        }
      }
    }
    return model?.contractingSystem?.tenderBasedFrameworkAgreementAdapt;

  }

  public visibilityNoNewTenderAM(model: any) {// SIN NUEVA LICITACION
    // Varios Adjudicatarios
    let someEntrepreneurs = model?.parent?.contractingSystem?.someEntrepreneurs != undefined && model?.parent?.contractingSystem?.someEntrepreneurs != null && model?.parent.contractingSystem?.someEntrepreneurs;

    if (!someEntrepreneurs) {
      return false;
    }

    // Campo del Paso 1 // PREVISTA_LICITACION_CBAM
    let plannedTenderBasedFrameworkAgreementAdapt = model?.parent?.contractingSystem?.plannedTenderBasedFrameworkAgreementAdapt;
    // Campo del Paso 2 // LICITACION_CBAM
    let tenderBasedFrameworkAgreementAdapt = model?.contractingSystem?.tenderBasedFrameworkAgreementAdapt;


    if (plannedTenderBasedFrameworkAgreementAdapt != undefined && plannedTenderBasedFrameworkAgreementAdapt != null) {
      if (plannedTenderBasedFrameworkAgreementAdapt == 0) {
        return true;
      } else if (plannedTenderBasedFrameworkAgreementAdapt == 1) {
        return false;
      } else if (plannedTenderBasedFrameworkAgreementAdapt == 2) {
        //Sin y Con nueva licitación
        //Sin lotes
        if (!model?.parent?.breakdownLot?.apportioned) {
          return true;
        } else {
          // Con lotes
          if (tenderBasedFrameworkAgreementAdapt != undefined && tenderBasedFrameworkAgreementAdapt != null) {

            if (tenderBasedFrameworkAgreementAdapt == 0) { // SIN NUEVA LICITACION
              return true;
            } else if (tenderBasedFrameworkAgreementAdapt == 1) {
              return false;
            } else if (tenderBasedFrameworkAgreementAdapt == 2) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  public visibilityNewTenderAM(model: any) {// SIN NUEVA LICITACION

    // Varios Adjudicatarios
    let someEntrepreneurs = model?.parent?.contractingSystem?.someEntrepreneurs != undefined && model?.parent?.contractingSystem?.someEntrepreneurs != null && model?.parent.contractingSystem?.someEntrepreneurs;

    if (!someEntrepreneurs) {
      return false;
    }

    // Campo del Paso 1 // PREVISTA_LICITACION_CBAM
    let plannedTenderBasedFrameworkAgreementAdapt = model?.parent?.contractingSystem?.plannedTenderBasedFrameworkAgreementAdapt;
    // Campo del Paso 2 // LICITACION_CBAM
    let tenderBasedFrameworkAgreementAdapt = model?.contractingSystem?.tenderBasedFrameworkAgreementAdapt;


    if (plannedTenderBasedFrameworkAgreementAdapt != undefined && plannedTenderBasedFrameworkAgreementAdapt != null) {
      if (plannedTenderBasedFrameworkAgreementAdapt == 0) {
        return false;
      } else if (plannedTenderBasedFrameworkAgreementAdapt == 1) {
        return true;
      } else if (plannedTenderBasedFrameworkAgreementAdapt == 2) {
        //Sin y Con nueva licitación
        //Sin lotes
        if (!model?.parent?.breakdownLot?.apportioned) {
          return true;
        } else {
          // Con lotes
          if (tenderBasedFrameworkAgreementAdapt != undefined && tenderBasedFrameworkAgreementAdapt != null) {
            if (tenderBasedFrameworkAgreementAdapt == 0) { // SIN NUEVA LICITACION
              return false;
            } else if (tenderBasedFrameworkAgreementAdapt == 1) {
              return true;
            } else if (tenderBasedFrameworkAgreementAdapt == 2) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }


  registerFunctions(frmConfig: FormConfig): void {
    frmConfig.functions.push({
      identifier: 'activeSomeEntrepreneurs',
      fn: this.activeSomeEntrepreneurs
    });
    frmConfig.functions.push({
      identifier: 'valueOnlyEntrepreneur',
      fn: this.valueOnlyEntrepreneur
    });
    frmConfig.functions.push({
      identifier: 'defaultValueOnlyEntrepreneur',
      fn: this.defaultValueOnlyEntrepreneur
    });

    frmConfig.functions.push({
      identifier: 'defaultValueSomeEntrepreneurs',
      fn: this.defaultValueSomeEntrepreneurs
    });

    frmConfig.functions.push({
      identifier: 'valueFrameworkAgreementAwardType',
      fn: this.valueFrameworkAgreementAwardType
    });

    frmConfig.functions.push({
      identifier: 'visibleAssumptionsNewTender',
      fn: this.visibleAssumptionsNewTender
    });
    frmConfig.functions.push({
      identifier: 'valuePlannedTenderBasedFrameworkAgreementAdapt',
      fn: this.valuePlannedTenderBasedFrameworkAgreementAdapt
    });
    frmConfig.functions.push({
      identifier: 'visiblePlannedTenderBasedFrameworkAgreementAdapt',
      fn: this.visiblePlannedTenderBasedFrameworkAgreementAdapt
    });
    frmConfig.functions.push({
      identifier: 'valueYearExercise_LotBudgetAccountLineAM',
      fn: this.valueYearExercise_LotBudgetAccountLineAM
    });
    frmConfig.functions.push({
      identifier: 'visibleDefinitiveGuaranteeTypeAM',
      fn: this.visibleDefinitiveGuaranteeTypeAM
    });
    frmConfig.functions.push({
      identifier: 'visibleComplementaryGuaranteeAM',
      fn: this.visibleComplementaryGuaranteeAM
    });
    frmConfig.functions.push({
      identifier: 'valueTenderBasedFrameworkAgreementAdaptAM',
      fn: this.valueTenderBasedFrameworkAgreementAdaptAM
    });
    frmConfig.functions.push({
      identifier: 'visibilityNoNewTenderAM',
      fn: this.visibilityNoNewTenderAM
    });
    frmConfig.functions.push({
      identifier: 'visibilityNewTenderAM',
      fn: this.visibilityNewTenderAM
    });





  }
}

